import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { medfordNjConfig } from "./data";

export default function MedfordNJPage() {
  return <CityPageTemplate config={medfordNjConfig} />;
}